module.exports = __webpack_public_path__ + "static/media/airplane-icon.c0d014b3.svg";